



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { VideoContainer, VideoAttributes } from '@/models/ResponsiveVideo';

@Component
export default class ResponsiveVideos extends Vue {
    @Prop() private externalClasses!: string;
    videos!: VideoContainer;
    autoplay: string = '';
    preload: string = '';
    loop: string = '';
    muted: string = '';
    controls: string = '';
    startTime: string = '';
    showAsPlayer: boolean = false;
    hidePlayButton: boolean = false;
    hasBrightText: boolean = false;
    
    play: boolean = false;
    landscapeOrientation: boolean = true;
    elementSizeRatio: boolean = true;
    playStarted: boolean = false;
    orientationSet: boolean = false;
    mp4Src: string = '';
    webmSrc: string = '';
    viewPlayPauseButton: boolean = false;

    constructor() {
        super();
        this.videos = JSON.parse(this.$attrs['data-video']);
        this.viewPlayPauseButton = this.$attrs['data-view-play-pause-button'] === 'true';
        this.autoplay = this.$attrs['data-video-autoplay'];
        this.preload = this.$attrs['data-video-preload'];
        this.loop = this.$attrs['data-video-loop'];
        this.muted = this.$attrs['data-video-muted'];
        this.controls = this.$attrs['data-video-controls'];

        if (typeof this.$attrs['data-has-bright-text'] !== 'undefined') {
            this.hasBrightText = this.$attrs['data-has-bright-text'] === 'True';
        }

        if (typeof this.$attrs['data-video-show-player'] !== 'undefined') {
            this.showAsPlayer = this.$attrs['data-video-show-player'] === 'True';
        }
        
        if (typeof this.$attrs['data-video-start'] !== 'undefined' && this.showAsPlayer) {
            this.startTime = ('#t=' + this.$attrs['data-video-start']).replace(/,/g, '.');
        }

        if (this.showAsPlayer) {
            this.autoplay = 'false';
            this.muted = 'false';
        }

        if (!this.videos.BackgroundVideoMp4Portrait) {
            this.videos.BackgroundVideoMp4Portrait = this.videos.BackgroundVideoMp4Landscape;
            this.videos.BackgroundVideoWebmPortrait = this.videos.BackgroundVideoWebmLandscape;
        }

        this.$attrs['data-video'] = '';
    }

    get videoAttributes(): VideoAttributes {
        const attributes: VideoAttributes = {};

        attributes.playsinline = 'playsinline';

        if (this.autoplay !== '' && this.autoplay !== undefined && this.autoplay !== 'false') {
            attributes['data-autoplay'] = this.autoplay;
        }

        if (this.preload !== '' && this.preload !== undefined && this.preload !== 'false') {
            attributes.preload = 'none';
        }

        if (this.loop !== '' && this.loop !== undefined && this.loop !== 'false') {
            attributes.loop = this.loop;
        }

        if (this.muted !== '' && this.muted !== undefined && this.muted !== 'false') {
            attributes.muted = this.muted;
        }

        if (this.controls !== '' && this.controls !== undefined && this.controls !== 'false') {
            attributes.controls = this.controls;
        }

        return attributes;
    }

    mounted() {
        this.loadCorrectClip();
    }

    private onVideoPlay() {
        this.play = true;
        if (!this.playStarted && this.showAsPlayer) {
            this.playStarted = true;
        }
    }

    private onVideoPause() {
        this.play = false;
    }

    private loadCorrectClip() {
        const isLandscape = window.outerWidth > window.outerHeight;
        if (isLandscape && this.videos.BackgroundVideoMp4Landscape && this.videos.BackgroundVideoWebmLandscape) {
            this.mp4Src = this.videos.BackgroundVideoMp4Landscape.Url + this.startTime;
            this.webmSrc = this.videos.BackgroundVideoWebmLandscape.Url + this.startTime;
        } else if (!isLandscape && this.videos.BackgroundVideoMp4Portrait && this.videos.BackgroundVideoWebmPortrait) {
            this.mp4Src = this.videos.BackgroundVideoMp4Portrait.Url + this.startTime;
            this.webmSrc = this.videos.BackgroundVideoWebmPortrait.Url + this.startTime;
        } else if (this.videos.BackgroundVideoMp4Landscape && this.videos.BackgroundVideoWebmLandscape) {
            this.mp4Src = this.videos.BackgroundVideoMp4Landscape.Url + this.startTime;
            this.webmSrc = this.videos.BackgroundVideoWebmLandscape.Url + this.startTime;
        } else if (this.videos.BackgroundVideoMp4Portrait && this.videos.BackgroundVideoWebmPortrait) {
            this.mp4Src = this.videos.BackgroundVideoMp4Portrait.Url + this.startTime;
            this.webmSrc = this.videos.BackgroundVideoWebmPortrait.Url + this.startTime;
        }
    }

    private togglePlay() {
        const video = this.$refs.videoPlayer as HTMLVideoElement | undefined;

        if (video) {
            if (this.play) {
                if(this.showAsPlayer) {
                    this.hidePlayButton = true;
                }
                video.pause();
            } else {
                if (!this.playStarted && this.showAsPlayer) {
                    video.currentTime = 0;
                    video.setAttribute('controls', 'controls');
                }
                video.play();
            }
        }
    }
}
